




















import {Component, Mixins} from 'vue-mixin-decorator';

import NetworkNetworkingStatus from '@/components/Networking/NetworkNetworkingStatus.vue';
import NetworkEthernetStatus from '@/components/Networking/Ethernet/NetworkEthernetStatus.vue';
import NetworkVpnStatus from '@/components/Networking/Vpn/NetworkVpnStatus.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkVpnStatus, NetworkEthernetStatus, NetworkNetworkingStatus},
})
export default class NetworkOverviewPage extends Mixins<BaseComponent>(BaseComponent) {


}
